import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'planningPackagesSpotsPipe'
})
export class PlanningPackagesSpotsPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(orderPackagesRef, enableSuffix?): unknown {

    let spotsSum;

    if (orderPackagesRef) {
      spotsSum = orderPackagesRef.reduce((acc, item) => {
        if (item.requiredSpots) {
          acc += (item.requiredSpots * (item.count || 1));
        }
        return acc;
      }, 0);
    }

    let decimalNumber = Number.isSafeInteger(spotsSum) ? 0 : 2;

    return enableSuffix ? this.translateService.instant(spotsSum == 1 ? 'X_SPOT' : 'X_SPOTS', {sum: spotsSum.toFixed(decimalNumber)}) : spotsSum.toFixed(decimalNumber);

  }

}
